module.exports = __webpack_public_path__ + "static/media/2-en.af1545c2.svg";